/**
 * Pré-carrega no celular tudo que os wizards de apontamento precisam
 * (equipes, OS ativas, itens e trechos de cada OS, composições).
 * Cada GET passa pelo interceptor do api.js, que grava no api_cache.
 */
import api from "@/lib/api";
import { PLACAS_DESENHO } from "@/data/contranSigns";

const LS_KEY = "pcp_offline_preload";
const AUTO_INTERVAL_MS = 30 * 60 * 1000;

export function getPreloadInfo() {
  try { return JSON.parse(localStorage.getItem(LS_KEY)) || null; } catch { return null; }
}

export async function preloadOfflineData() {
  const [ordens] = await Promise.all([
    api.get("/ordens").then((r) => r.data),
    api.get("/equipes"),
    api.get("/composicoes"),
  ]);
  const ativas = (ordens || []).filter((o) => o.status !== "Concluída" && o.status !== "Cancelada");
  let itens = 0;
  for (const os of ativas) {
    const [it] = await Promise.all([
      api.get(`/itens?os_id=${os.id}`).then((r) => r.data),
      api.get(`/ordens/${os.id}/trechos`).catch(() => null),
    ]);
    itens += (it || []).length;
  }
  // Desenhos das placas (SVG) no cache do service worker — só os que faltam, 4 por vez, para não disputar o sinal
  if ("caches" in window) {
    try {
      const faltam = [];
      for (const c of PLACAS_DESENHO) { if (!(await caches.match(`/placas/${c}.svg`))) faltam.push(c); }
      for (let i = 0; i < faltam.length; i += 4) {
        await Promise.all(faltam.slice(i, i + 4).map((c) => fetch(`/placas/${c}.svg`).catch(() => null)));
      }
    } catch { /* sem bloqueio */ }
  }
  const info = { at: Date.now(), ordens: ativas.length, itens };
  localStorage.setItem(LS_KEY, JSON.stringify(info));
  window.dispatchEvent(new Event("offline-preload-changed"));
  return info;
}

// Conexão ruim (2G / economia de dados): não disputa banda com o uso normal
export function conexaoFraca() {
  const c = navigator.connection;
  return !!c && (c.saveData || c.effectiveType === "slow-2g" || c.effectiveType === "2g");
}

export async function autoPreloadIfStale() {
  if (!navigator.onLine || !localStorage.getItem("pcp_token") || conexaoFraca()) return null;
  const info = getPreloadInfo();
  if (info && Date.now() - info.at < AUTO_INTERVAL_MS) return null;
  try { return await preloadOfflineData(); } catch { return null; }
}
